/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
/**
 * Delete Notification
 * @export
 * @interface NotificationDelete
 */
export interface NotificationDelete {
    /**
     * Displays if notification was successfully deleted
     * @type {boolean}
     * @memberof NotificationDelete
     */
    success?: boolean;
}

/**
 * Check if a given object implements the NotificationDelete interface.
 */
export function instanceOfNotificationDelete(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationDeleteFromJSON(json: any): NotificationDelete {
    return NotificationDeleteFromJSONTyped(json, false);
}

export function NotificationDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationDelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function NotificationDeleteToJSON(value?: NotificationDelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

